import BaseDataManager from '@copilot/data/managers/base';
import { isString } from 'lodash';

class AIFeatureManager extends BaseDataManager {
    constructor() {
        super();
        this.acceptTermsOfUse = this.acceptTermsOfUse.bind(this);
        this.hasAcceptTermsOfUse = this.hasAcceptTermsOfUse.bind(this);
        this.acknowledgeAIDataUsageTermsOfUse = this.acknowledgeAIDataUsageTermsOfUse.bind(this);
        this.hasAcknowledgedAIDataUsageTermsOfUse =
            this.hasAcknowledgedAIDataUsageTermsOfUse.bind(this);
    }

    /**
     * Accept ai feature's terms of use
     */
    public async acceptTermsOfUse() {
        const url = this.combineRoute(this.BACKEND_ROUTES.AI_FEATURE.Default, 'acceptTerms');
        await this.RequestManager.post(url);
    }

    /**
     * Get if the current user has accepted ai feature's terms of use
     */
    public async hasAcceptTermsOfUse() {
        const url = this.combineRoute(this.BACKEND_ROUTES.AI_FEATURE.Default, 'acceptTerms');
        const response = await this.RequestManager.get<boolean>(url);
        return response.data;
    }

    /**
     * Acknowledge AI Data Usage Terms of Use
     */
    public async acknowledgeAIDataUsageTermsOfUse(orgMemberId?: string) {
        const acknowledgePath = isString(orgMemberId)
            ? `acknowledgeTerms/${orgMemberId}`
            : 'acknowledgeTerms';
        const url = this.combineRoute(this.BACKEND_ROUTES.AI_FEATURE.Default, acknowledgePath);
        await this.RequestManager.post(url);
    }

    /**
     * Get if the current user or the specified org member has acknowledged ai feature's terms of use
     */
    public async hasAcknowledgedAIDataUsageTermsOfUse(orgMemberId?: string) {
        const acknowledgePath = isString(orgMemberId)
            ? `acknowledgeTerms/${orgMemberId}`
            : 'acknowledgeTerms';
        const url = this.combineRoute(this.BACKEND_ROUTES.AI_FEATURE.Default, acknowledgePath);
        const response = await this.RequestManager.get<boolean>(url);
        return response.data;
    }
}

const instance = new AIFeatureManager();
export default instance;
